import { render } from "./App.vue?vue&type=template&id=63524cd9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=63524cd9&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/dariem.kz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__